import { CheckCircleIcon, ArrowDownTrayIcon, PrinterIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'

import { downloadAmicalCaQuote, printAmicalCaQuote } from './printAmicalCaQuote'

const AmicalCaReservationSuccess = ({ reservationRef, quoteParams, onClose }) => {
  const { t } = useTranslation()

  const handlePrint = () => {
    printAmicalCaQuote({ ...quoteParams, reservationRef })
  }

  const handleDownload = () => {
    downloadAmicalCaQuote({ ...quoteParams, reservationRef })
  }

  return (
    <div className="flex flex-col items-center px-4 py-10 text-center sm:px-8">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full border border-green-200 bg-green-50">
        <CheckCircleIcon className="h-10 w-10 text-green-600" />
      </div>

      <h3 className="mb-2 max-w-2xl text-base font-bold text-gray-900 sm:text-lg">
        {t('amicales.success.title')}
      </h3>

      {reservationRef ? (
        <p className="mb-6 text-sm text-gray-500">
          {t('amicales.success.reference')}{' '}
          <strong className="text-gray-800">{reservationRef}</strong>
        </p>
      ) : (
        <div className="mb-6" />
      )}

      <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:gap-3">
        <button
          type="button"
          onClick={handleDownload}
          className="modern-btn inline-flex items-center justify-center gap-2"
        >
          <ArrowDownTrayIcon className="h-4 w-4" />
          {t('amicales.success.downloadQuote')}
        </button>
        <button
          type="button"
          onClick={handlePrint}
          className="modern-btn-outline inline-flex items-center justify-center gap-2"
        >
          <PrinterIcon className="h-4 w-4" />
          {t('amicales.success.print')}
        </button>
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-700 transition hover:bg-gray-50"
        >
          {t('common.close')}
        </button>
      </div>
    </div>
  )
}

export default AmicalCaReservationSuccess
